module.exports = __webpack_public_path__ + "img/CriticalHeightDetails-min.503ee9a9.png";